import { render, staticRenderFns } from "./SendInvoicesFromSingleOrder.vue?vue&type=template&id=448f4143&"
import script from "./SendInvoicesFromSingleOrder.vue?vue&type=script&lang=js&"
export * from "./SendInvoicesFromSingleOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports